<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m12 20.924-8.693-9.066a5.142 5.142 0 0 1-.963-5.94v0a5.143 5.143 0 0 1 8.236-1.336L12 6.001l1.42-1.419a5.143 5.143 0 0 1 7.274 7.273L12 20.925Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
